export const INVOICING_INTEGRATION_KEY = 'ls-retail';
const INVOICING_REF_PREFIX = `${INVOICING_INTEGRATION_KEY}_`;

/**
 * Formats a reference ID with the ls-retail_ prefix.
 * If the ID already has the prefix, it returns it unchanged.
 *
 * @param referenceId The reference ID to format
 * @returns The formatted reference ID with ls-retail_ prefix
 */
export const formatRefId = (referenceId: string): string => {
  if (referenceId.startsWith(INVOICING_REF_PREFIX)) {
    return referenceId;
  }
  return `${INVOICING_REF_PREFIX}${referenceId}`;
};
